(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector(
					'input[name="locale_code"], input[name="country_code"]'
				),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener(
				'click',
				this.openSelector.bind(this)
			);
			this.elements.button.addEventListener(
				'focusout',
				this.closeSelector.bind(this)
			);
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach((item) =>
				item.addEventListener('click', this.onItemClick.bind(this))
			);
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute(
				'aria-expanded',
				(
					this.elements.button.getAttribute('aria-expanded') === 'false'
				).toString()
			);
		}

		closeSelector(event) {
			const shouldClose =
				event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
	this.header = document.querySelector('.shopify-section-header');
	this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
	this.headerBounds = {};
	this.currentScrollTop = 0;
	this.preventReveal = false;

	if (this.headerIsAlwaysSticky) {
	this.header.classList.add('shopify-section-header-sticky');
	this.header.classList.add('always-fixed');
	};

	this.onScrollHandler = this.onScroll.bind(this);
	this.hideHeaderOnScrollUp = () => this.preventReveal = true;
	this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
	window.addEventListener('scroll', this.onScrollHandler, false);

	this.createObserver();
	}

	disconnectedCallback() {
	this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
	window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
	let observer = new IntersectionObserver((entries, observer) => {
	this.headerBounds = entries[0].intersectionRect;
	observer.disconnect();
	});

	observer.observe(this.header);
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
	if (this.preventHide) return;
	requestAnimationFrame(this.hide.bind(this));
	} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
	if (!this.preventReveal) {
	requestAnimationFrame(this.reveal.bind(this));
	}else {
	window.clearTimeout(this.isScrolling);

	this.isScrolling = setTimeout(() => {
	this.preventReveal = false;
	}, 66);

	requestAnimationFrame(this.hide.bind(this));
	}
	} else if (scrollTop <= this.headerBounds.top) {
	requestAnimationFrame(this.reset.bind(this));
	}

	this.currentScrollTop = scrollTop;
	}

	hide() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
	this.closeMenuDisclosure();
	}

	reveal() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.add('shopify-section-header-sticky', 'animate');
	this.header.classList.add('shopify-section-header-sticky', 'animate');
	this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
	this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
	this.disclosures.forEach(disclosure => disclosure.close());
	}

	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
				element.classList.remove('active');
			}
		)
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		if (activeMedia) {
			activeMedia.classList.add('active');
			activeMedia.scrollIntoView();
		}
		
		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations--single');
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}
				})
				.catch(e => {
					console.error(e);
				});
		}

		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}

customElements.define('product-modal', ProductModal);
customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moonless-announcement"] && !Shopify.designMode) return;
  try {
    
	/* Cycles the announcement slides. Grid stacking in the CSS keeps every slide in the same
	   cell, so the bar is always as tall as its tallest line and never shifts the page. */
	if (!customElements.get('moonless-rotator')) {
		customElements.define(
			'moonless-rotator',
			class MoonlessRotator extends HTMLElement {
				connectedCallback() {
					this.slides = Array.from(this.querySelectorAll('.ml-announce__slide'));
					if (!this.slides.length) return;
					/* Tell the CSS that JS is driving now. Without this the stylesheet keeps its
					   no-JS fallback up (":not(.is-live) .ml-announce__slide:first-child" stays at
					   full opacity), so the first message sat on top of whichever message had
					   .is-on and the two printed over each other in the same grid cell. */
					this.classList.add('is-live');
					this.at = 0;
					this.slides[0].classList.add('is-on');
					/* A countdown message hides itself the second its deadline passes, which can land
					   between two rotations. Watch for it so the strip never sits on a blank message,
					   and so the strip takes itself off the page entirely once nothing is left to say
					   rather than staying pinned to the top of the window as an empty black line. */
					this.sync();
					if (window.MutationObserver) {
						this.mo = new MutationObserver(() => this.sync());
						this.slides.forEach((s) => this.mo.observe(s, { attributes: true, attributeFilter: ['hidden'] }));
					}
					if (this.slides.length < 2) return;
					this.timer = setInterval(() => {
						this.slides[this.at].classList.remove('is-on');
						this.at = this.next(this.at);
						this.slides[this.at].classList.add('is-on');
					}, Number(this.dataset.interval) || 4500);
				}
				/* A countdown message hides itself when its deadline passes. Step over it instead
				   of parking an empty bar there for four seconds, and fall back to standing still
				   if every message has expired. */
				next(from) {
					for (let i = 1; i <= this.slides.length; i++) {
						const j = (from + i) % this.slides.length;
						if (!this.slides[j].hidden) return j;
					}
					return from;
				}
				/* Keeps the strip honest about what is left on it. */
				sync() {
					const live = this.slides.filter((s) => !s.hidden);
					this.hidden = live.length === 0;
					if (!live.length) return;
					if (this.slides[this.at].hidden) {
						this.slides[this.at].classList.remove('is-on');
						this.at = this.next(this.at);
						this.slides[this.at].classList.add('is-on');
					}
				}
				disconnectedCallback() {
					if (this.timer) clearInterval(this.timer);
					if (this.mo) this.mo.disconnect();
				}
			}
		);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moonless-recommendations"] && !Shopify.designMode) return;
  try {
    
	/*
	 * Its own element name, deliberately.
	 *
	 * sections/product-recommendations.liquid defines <product-recommendations> and does it
	 * unguarded, and every section's javascript block is bundled into one file that loads on
	 * every page. So whichever definition ran first won, and when it was the theme's, this
	 * section's markup was driven by a class that knows nothing about the wrapper it has to
	 * unhide. Both rows stayed blank. A name of our own cannot be taken.
	 */
	if (!customElements.get('moonless-recommendations')) {
		customElements.define(
			'moonless-recommendations',
			class MoonlessRecommendations extends HTMLElement {
				/*
				 * connectedCallback, once, and only for an element that is in the page.
				 *
				 * This used to run from the constructor, and the response was parsed into a plain
				 * div. That div belongs to the document, so the <moonless-recommendations> inside the
				 * fetched HTML was upgraded on the spot and its constructor fired another fetch, whose
				 * response did the same, forever: 115 requests a second from every open product page,
				 * about 33,000 DOM nodes a second built and thrown away, a core of CPU and a hot laptop
				 * (reported 2026-10-08). The response is now parsed into a <template>, whose content
				 * is inert, and a detached copy never starts anything.
				 */
				connectedCallback() {
					if (this._mlStarted || !this.isConnected) return;
					this._mlStarted = true;

					const reveal = () => {
						const wrap = this.closest('[data-ml-recs]');
						if (wrap) wrap.classList.remove('is-empty');
					};

					/* Only the grid is taken. The heading and the button live outside this element
					   so they keep this instance's settings rather than the schema defaults the
					   standalone render comes back with. */
					const load = (url, fallback) => {
						fetch(url)
							.then((response) => response.text())
							.then((text) => {
								const html = document.createElement('template');
								html.innerHTML = text;
								const fetched = html.content.querySelector('moonless-recommendations');
								const grid = fetched && fetched.querySelector('.ml-recs__grid');

								if (grid && grid.children.length) {
									this.innerHTML = fetched.innerHTML;
									reveal();
								} else if (fallback) {
									load(fallback, null);
								}
							})
							.catch((e) => {
								console.error(e);
							});
					};

					/* Deliberately not an IntersectionObserver.
					 *
					 * The observer version dropped the row whenever someone flicked past it and
					 * came back: the callback is async and batched, so a fast scroll delivers one
					 * entry that is already not intersecting, the handler bails, and nothing ever
					 * scrolls it into view again. These two rows are the reason the page has a
					 * middle, so they fetch once the browser is idle and stop being conditional
					 * on catching a scroll at the right moment. */
					const start = () => load(this.dataset.url, this.dataset.fallbackUrl);

					if ('requestIdleCallback' in window) {
						requestIdleCallback(start, { timeout: 1500 });
					} else {
						setTimeout(start, 400);
					}
				}
			}
		);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
